export let PREMIUM_PLANS = /*#__PURE__*/function (PREMIUM_PLANS) {
  PREMIUM_PLANS["FREE"] = "Free";
  PREMIUM_PLANS["PREMIUM"] = "Premium";
  PREMIUM_PLANS["NONE"] = "";
  return PREMIUM_PLANS;
}({});
//# sourceMappingURL=premium-plans.js.map